export const POLL_TYPES = {
    POLL: 'POLL',
    H2H: 'H2H',
    TOP_THREE: 'TOP_THREE',
    TRIVIA: 'TRIVIA',
    FREE_TEXT: 'FREE_TEXT'
};

// Set by the poll response when a voting poll has video. Absent = no video.
export const POLL_VIDEO_TYPES = {
    WIDGET: 'widget',
    OPTION: 'option'
};
